export default __webpack_public_path__ + "static/media/camera-3.2a4ac2c3.png";